// extracted by mini-css-extract-plugin
export default {"slidercontainer":"Slider_slidercontainer__8Ie6K","slidetext":"Slider_slidetext__q5gzq","boxblack":"Slider_boxblack__qNhBg"};